/** Visual step extracted from ComeBackSection; caller supplies counts and captions. */
import { Figure, Note } from './InsightsBlocks'
import { useAnimateWhenVisible } from '../../hooks/useAnimateWhenVisible'
import '../shims/ProgressBarShim.css'

export function PopulationStep({
  arrow,
  label,
  value,
  share,
  max,
  formatCount: n,
  accessibilityLabel,
  primary = false,
}: {
  arrow: boolean
  label: string
  value: number
  share?: string
  max: number
  formatCount: (x: number) => string
  accessibilityLabel?: string
  primary?: boolean
}) {
  const { ref, hasBeenVisible } = useAnimateWhenVisible<HTMLDivElement>()
  let arrowIcon = null
  if (arrow) arrowIcon = <s-icon type="arrow-right" color="subdued" />
  let caption = null
  if (share) caption = <Note>{share}</Note>
  let labelNode = <Note>{label}</Note>
  if (primary) labelNode = <s-text fontWeight="medium">{label}</s-text>
  return (
    <s-stack gap="small-200" blockSize="100%">
      <s-stack direction="inline" gap="small-100" alignItems="center">
        {arrowIcon}
        {labelNode}
      </s-stack>
      <div style={{ flexGrow: 1 }}>
        <s-stack gap="small-200">
          <Figure size="large-200">{n(value)}</Figure>
          {caption}
        </s-stack>
      </div>
      <div
        ref={ref}
        className={`tf-progress-fill${hasBeenVisible ? ' tf-progress-fill--visible' : ''}`}
        style={{ inlineSize: '100%' }}
      >
        <s-progress
          value={value}
          max={max}
          accessibilityLabel={accessibilityLabel ?? `${label}, ${n(value)} of ${n(max)} shoppers`}
        />
      </div>
    </s-stack>
  )
}
